// Module
var code = "<input class=\"form-control ng-pristineng-touched\" ng-change=\"$ctrl.change()\" ng-model=\"$ctrl.ngModel\"> <span ng-if=\"$ctrl.error\" style=\"color:#a94442\">{{$ctrl.messageError}} </span> ";
// Exports
module.exports = code;